import { mapUrlToPageLogProps, Page } from 'components/Logs'
import Main from './ContractsMain'
import Show from './ContractsShow'
import Edit from './ContractsEdit'
import New from './ContractsNew'
import Steps from './MigratePlanSteps'
import Suspend from './ContractsSuspend'

export default {
  New,
  Main,
  Show,
  Edit,
  Steps,
  Suspend,
  Logs: mapUrlToPageLogProps(({ params }) => ({
    title: 'Assinatura',
    entity: 'contract',
    entityId: params.contractId,
  }))(Page),
}
